import { Component } from '@verndale/core';
import ImageModal from './image-modal';

class ImageGalleryRow extends Component {
  constructor(el: HTMLElement) {
    super(el);

    if (this.dom.modal) {
      new ImageModal(this.dom.modal as HTMLElement);
    }
  }

  setupDefaults() {
    this.dom = {
      modal: document.getElementById('image-modal'),
      navUp: this.el.querySelector('.image-gallery__nav--up') as HTMLElement,
      navDown: this.el.querySelector('.image-gallery__nav--down') as HTMLElement
    };
  }

  addListeners() {
    (this.dom.navUp as HTMLButtonElement).addEventListener('click', () => {
      window.scrollBy({ top: -150, behavior: 'smooth' });
    });

    (this.dom.navDown as HTMLButtonElement).addEventListener('click', () => {
      window.scrollBy({ top: 150, behavior: 'smooth' });
    });
  }
}

export default ImageGalleryRow;
